// src/belediye/services/pushIstemci.js
//
// FAZ-84 — TELEFON BİLDİRİMİ İSTEMCİSİ (sayfa tarafı)
//
// Nöbetçi (public/sw.js) bilerek aptaldır: iş mantığı burada, sayfada durur.
// Bu dosyanın sorumlulukları:
//   1. Nöbetçiyi kaydetmek ve HER AÇILIŞTA güncellemek,
//   2. İzin/abonelik durumunu okumak (rehber ekranı buna bakar),
//   3. Aboneliği açıp kapatmak ve sunucuyla eşitlemek,
//   4. Uzaktan kapatma bayrağını okuyup nöbetçiyi söktürmek.
//
// TARAYICI DESTEĞİ YOKSA HİÇBİR ŞEY PATLAMAZ: her giriş noktası önce
// destekVar() sorar ve desteklenmeyen ortamda sessizce "yok" döner.

import {
  pushAnahtarAl,
  pushDurumAl,
  pushAboneOl,
  pushAbonelikSil,
  pushAbonelikKontrol,
} from "./bildirimApi";

// ── SÜRÜM ───────────────────────────────────────────────────────────────────
// Nöbetçinin sürümü TEK BİR YERDE, burada tutulur. sw.js kendi sürümünü
// bilmez; sürüm kayıt adresine `?v=N` olarak yazılır. Böylece:
//   • İki yerde tutulup birbirinden sapamaz.
//   • N değişince kayıt adresi değişir → tarayıcı yeni nöbetçiyi KESİN alır.
//   • Abonelik kaydında sunucuya bildirilir → yöneticide "kim eskide kaldı".
//
// ⚠️ sw.js'te ANLAMLI bir değişiklik yapıldığında BU SAYI ARTIRILMALIDIR.
//
// v2 (FAZ-102): nöbetçiye BOŞ bir `fetch` dinleyicisi eklendi. Chrome, bu
// dinleyici olmadan siteyi "kurulabilir" saymıyor ve `beforeinstallprompt`
// olayını hiç göndermiyor — yani Android'de tek dokunuşla kurulum mümkün
// olmuyordu. Dinleyici `respondWith` çağırmadığı için hiçbir şey önbelleğe
// alınmaz; FAZ-84 §7.1 güvencesi aynen durur.
// v3 (FAZ-104): bildirim rozeti ayrı bir tek-renk dosyaya bağlandı
// (`/bildirim-rozet.png`). Android renkli logoyu maskeleyip tanınmaz bir
// lekeye çeviriyordu.
// v4 (FAZ-106): TEK YÜZEY KURALI. (a) Uygulama açık ve GÖRÜNÜRKEN nöbetçi
// telefon bildirimi göstermez, yalnız sayfayı dürter — işi toast yapar.
// (b) Gösterdiği bildirimlerin kimliğini IndexedDB defterine yazar; sayfa
// açılınca o kimlikler bir daha toast edilmez. İkisi birlikte "aynı olay iki
// kez kesinti yapmasın" isteğinin karşılığıdır.
// v5 (FAZ-115): rozet TEK dosya olmaktan çıkıp SÖZLÜĞE dönüştü — durum çubuğu
// simgesi artık kaynağa göre değişiyor (mesaj/talep/başvuru/duyuru), bildirimin
// damgası sunucudan gelen gerçek olay zamanı ve yedek başlıktaki belediye adı
// sabiti söküldü. Nöbetçi dosyası değiştiği için sürüm ŞART: `?v=` değişmezse
// tarayıcı cihazdaki eski nöbetçiyi kullanmaya devam eder ve rozetler
// telefonlarda hiç güncellenmez.
export const SW_SURUM = 5;

const SW_YOL = `/sw.js?v=${SW_SURUM}`;

// ── Ortam tespiti ───────────────────────────────────────────────────────────

export const destekVar = () => {
  try {
    return (
      typeof navigator !== "undefined" &&
      "serviceWorker" in navigator &&
      typeof window !== "undefined" &&
      "PushManager" in window &&
      "Notification" in window
    );
  } catch (_) {
    return false;
  }
};

/** Ana ekrandan (uygulama olarak) mı açılmış?
 *
 * İKİ kontrol birden gerekir: iOS bazı sürümlerde `display-mode` sorgusunu
 * yanlış cevaplar, ama kendi `navigator.standalone` bayrağını doğru verir.
 * Tek kontrole güvenmek, iPhone kullanıcısına yanlış rehber göstermek demek.
 */
export const standaloneMi = () => {
  try {
    const medya =
      typeof window.matchMedia === "function" &&
      window.matchMedia("(display-mode: standalone)").matches;
    const ios = window.navigator && window.navigator.standalone === true;
    return Boolean(medya || ios);
  } catch (_) {
    return false;
  }
};

/** Kaba platform tespiti — YALNIZ rehber metnini seçmek için. */
export const platformTespit = () => {
  try {
    const ua = (navigator.userAgent || "").toLowerCase();
    if (/iphone|ipad|ipod/.test(ua)) return "ios";
    // iPadOS 13+ masaüstü Safari gibi görünür; dokunma noktası sayısı ele verir.
    if (/macintosh/.test(ua) && (navigator.maxTouchPoints || 0) > 1) return "ios";
    if (/android/.test(ua)) return "android";
    return "masaustu";
  } catch (_) {
    return "masaustu";
  }
};

/** iOS'ta Safari DIŞI bir tarayıcı mı? (Chrome/Firefox'ta "Ana Ekrana Ekle"
 *  akışı farklıdır ve eski iOS sürümlerinde push hiç çalışmaz.) */
export const iosSafariDisiMi = () => {
  try {
    if (platformTespit() !== "ios") return false;
    const ua = navigator.userAgent || "";
    return /CriOS|FxiOS|EdgiOS|OPiOS/i.test(ua);
  } catch (_) {
    return false;
  }
};

export const izinDurumu = () => {
  try {
    return (window.Notification && window.Notification.permission) || "default";
  } catch (_) {
    return "default";
  }
};

// ── ANDROID: TEK DOKUNUŞLA KURULUM ─────────────────────────────────────────
//
// Chrome, site kurulabilir olduğunda `beforeinstallprompt` olayını gönderir.
// Olayı YAKALAYIP SAKLAMAZSAK tarayıcı kendi (çok siliktir) çubuğunu gösterip
// geçer ve bir daha o oturumda göndermez — yani "Uygulamayı yükle" düğmemiz
// hiç çalışmaz. Bu yüzden dinleyici MODÜL YÜKLENİRKEN kurulur; bileşenin
// monte olmasını beklersek olay çoktan geçmiş olabilir.
//
// iOS'ta bu olay HİÇ YOKTUR (Apple programatik kuruluma izin vermez) — orada
// rehber, Paylaş düğmesini gösteren anlatıma düşer.
let kurulumOlayi = null;
let kurulumDinleyicileri = [];

const kurulumHaberVer = () => {
  kurulumDinleyicileri.forEach((f) => {
    try {
      f(Boolean(kurulumOlayi));
    } catch (_) {}
  });
};

try {
  if (typeof window !== "undefined" && window.addEventListener) {
    window.addEventListener("beforeinstallprompt", (e) => {
      try {
        e.preventDefault(); // tarayıcının kendi çubuğunu bastır
      } catch (_) {}
      kurulumOlayi = e;
      kurulumHaberVer();
    });
    // Kurulum bittiğinde saklanan olay ÇÖPE ATILIR: aynı olay ikinci kez
    // kullanılamaz ve elde tutmak "hâlâ kurulabilir" yalanını sürdürür.
    window.addEventListener("appinstalled", () => {
      kurulumOlayi = null;
      kurulumHaberVer();
    });
  }
} catch (_) {}

/** Android'de sistem kurulum penceresi açılabilir mi? */
export const kurulumPenceresiVar = () => Boolean(kurulumOlayi);

/** Kurulabilirlik değişince haber ver (rehber ekranı adımını tazeler). */
export function kurulumDinle(fn) {
  if (typeof fn !== "function") return () => {};
  kurulumDinleyicileri.push(fn);
  return () => {
    kurulumDinleyicileri = kurulumDinleyicileri.filter((x) => x !== fn);
  };
}

/**
 * Sistem kurulum penceresini açar. Döner: "kuruldu" | "vazgecti" | "yok".
 * MUTLAKA bir kullanıcı dokunuşundan çağrılmalı.
 */
export async function kurulumBaslat() {
  if (!kurulumOlayi) return "yok";
  const olay = kurulumOlayi;
  // Olay TEK KULLANIMLIK: prompt() ikinci kez çağrılamaz. Referansı hemen
  // bırakıyoruz ki çift dokunuş sessiz bir hataya dönüşmesin.
  kurulumOlayi = null;
  kurulumHaberVer();
  try {
    await olay.prompt();
    const sonuc = await olay.userChoice;
    return sonuc && sonuc.outcome === "accepted" ? "kuruldu" : "vazgecti";
  } catch (_) {
    return "vazgecti";
  }
}

// ── Nöbetçi kaydı ───────────────────────────────────────────────────────────

const b64ToUint8 = (base64) => {
  const dolgu = "=".repeat((4 - (base64.length % 4)) % 4);
  const duz = (base64 + dolgu).replace(/-/g, "+").replace(/_/g, "/");
  const ham = window.atob(duz);
  const cikti = new Uint8Array(ham.length);
  for (let i = 0; i < ham.length; i += 1) cikti[i] = ham.charCodeAt(i);
  return cikti;
};

/** Nöbetçiyi kaydeder ve güncellemesini tetikler.
 *
 * `updateViaCache: "none"`: nöbetçi betiği ASLA HTTP önbelleğinden okunmaz.
 * nginx tarafında da `no-store` var (md_frontend/nginx.conf) — kuşak + kemer.
 * Bu ikili olmadan, düzeltilmiş bir sürüm cihaza inmeyebilirdi.
 */
export async function swKaydet() {
  if (!destekVar()) return null;
  try {
    const kayit = await navigator.serviceWorker.register(SW_YOL, {
      scope: "/",
      updateViaCache: "none",
    });
    // Her açılışta güncelleme yoklaması: hatalı bir sürüm, kullanıcı uygulamayı
    // BİR KEZ açtığı anda düzeltilmiş sürümle değişir (FAZ-84 §7.2).
    try {
      await kayit.update();
    } catch (_) {}
    return kayit;
  } catch (e) {
    // Kayıt başarısızsa uygulama ETKİLENMEZ; yalnız bildirim gelmez.
    return null;
  }
}

export async function kayitAl() {
  if (!destekVar()) return null;
  try {
    return (await navigator.serviceWorker.getRegistration("/")) || null;
  } catch (_) {
    return null;
  }
}

/** Kayıtlı TÜM nöbetçileri söker. Kill-switch ve "kapat" düğmesi kullanır. */
export async function swSok() {
  if (!destekVar()) return 0;
  let sayi = 0;
  try {
    const kayitlar = await navigator.serviceWorker.getRegistrations();
    for (const k of kayitlar) {
      try {
        if (await k.unregister()) sayi += 1;
      } catch (_) {}
    }
  } catch (_) {}
  return sayi;
}

// ── Durum ───────────────────────────────────────────────────────────────────

/** Rehber ekranının tek veri kaynağı. Hiçbir koşulda patlamaz. */
export async function durumOku() {
  const temel = {
    destek: destekVar(),
    standalone: standaloneMi(),
    platform: platformTespit(),
    iosBaskaTarayici: iosSafariDisiMi(),
    izin: izinDurumu(),
    abone: false,
    // FAZ-101 — SUNUCUNUN GÖRÜŞÜ. "aktif" | "pasif" | "yok" | "bilinmiyor".
    // Tarayıcıdaki abonelik nesnesi tek başına yeterli değil: sunucudaki
    // karşılığı ölmüş olabilir ve ekran yine "Açık" yazar (bkz. kopukMu).
    sunucuAbone: "bilinmiyor",
    sunucuAktif: false,
    anahtar: "",
  };
  if (!temel.destek) return temel;

  try {
    const d = await pushAnahtarAl();
    temel.sunucuAktif = Boolean(d && d.aktif && d.public_key);
    temel.anahtar = (d && d.public_key) || "";
  } catch (_) {}

  let uc = "";
  try {
    const kayit = await kayitAl();
    if (kayit && kayit.pushManager) {
      const abonelik = await kayit.pushManager.getSubscription();
      temel.abone = Boolean(abonelik);
      if (abonelik) uc = abonelik.endpoint || "";
    }
  } catch (_) {}

  // Sunucuya sor: bu cihazın aboneliğini görüyor mu?
  if (uc) temel.sunucuAbone = await abonelikKontrolEt(uc);

  return temel;
}

/** Tarayıcı "abone" diyor ama sunucu tanımıyor → bağlantı kopmuş.
 *
 *  Bu ayrımı yapmayan bir ekran, kişiye elinde tek çare olarak "uygulamayı sil
 *  ve yeniden kur"u bırakır. Oysa yapılması gereken tek şey aboneliği
 *  tazelemektir; silmeye de yeniden kurmaya da gerek yoktur.
 */
export const kopukMu = (durum) =>
  Boolean(durum && durum.abone && (durum.sunucuAbone === "yok" || durum.sunucuAbone === "pasif"));

/**
 * FAZ-101 — BAĞLANTIYI ONAR. Uygulama SİLİNMEDEN, yeniden KURULMADAN.
 *
 * Eski aboneliği bırakır, yenisini oluşturur ve sunucuya yazar. İzin zaten
 * verilmiş olduğu için kişiye hiçbir soru sorulmaz — tek dokunuşta biter.
 */
export async function pushOnar() {
  if (!destekVar()) return { ok: false, hata: "Bu tarayıcı bildirimi desteklemiyor." };
  try {
    const kayit = (await kayitAl()) || (await swKaydet());
    if (!kayit || !kayit.pushManager) {
      return { ok: false, hata: "Arka plan bileşeni kurulamadı." };
    }
    const eski = await kayit.pushManager.getSubscription();
    if (eski) {
      try {
        await eski.unsubscribe();
      } catch (_) {}
    }
    // Anahtar sunucudan TAZE alınır: onarımın sebebi anahtarın değişmesi
    // olabilir; eski aboneliğin anahtarını yeniden kullanmak, aynı arızayı
    // bir kez daha kurmak olurdu.
    const d = await pushAnahtarAl();
    if (!d || !d.aktif || !d.public_key) {
      return { ok: false, hata: "Telefon bildirimi şu anda kapalı." };
    }
    const yeni = await kayit.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: b64ToUint8(d.public_key),
    });
    await aboneligiSunucuyaYaz(yeni);
    return { ok: true, hata: "" };
  } catch (_) {
    return { ok: false, hata: "Bağlantı yenilenemedi. Sayfayı kapatıp yeniden açın." };
  }
}

// ── Aç / kapat ──────────────────────────────────────────────────────────────

const aboneligiSunucuyaYaz = async (abonelik) => {
  const ham = abonelik.toJSON ? abonelik.toJSON() : abonelik;
  return pushAboneOl({
    endpoint: ham.endpoint,
    keys: ham.keys || {},
    sw_surum: SW_SURUM,
    standalone: standaloneMi(),
  });
};

/**
 * İzin ister ve aboneliği açar. Döner: {ok, hata}
 *
 * ÖNEMLİ: bu fonksiyon MUTLAKA bir kullanıcı dokunuşundan (tıklama) çağrılmalı.
 * iOS izin istemini yalnız kullanıcı hareketiyle gösterir; otomatik çağrı
 * sessizce reddedilir ve kişi bir daha hiç sorulmadığını sanır.
 */
export async function pushAc() {
  if (!destekVar()) return { ok: false, hata: "Bu tarayıcı bildirimi desteklemiyor." };

  let anahtar = "";
  try {
    const d = await pushAnahtarAl();
    if (!d || !d.aktif || !d.public_key) {
      return { ok: false, hata: "Telefon bildirimi şu anda kapalı." };
    }
    anahtar = d.public_key;
  } catch (_) {
    return { ok: false, hata: "Sunucuya ulaşılamadı." };
  }

  let izin = izinDurumu();
  if (izin === "default") {
    try {
      izin = await window.Notification.requestPermission();
    } catch (_) {
      izin = "denied";
    }
  }
  if (izin !== "granted") {
    return {
      ok: false,
      hata:
        "Bildirim izni verilmedi. Telefon ayarlarından bu uygulamaya bildirim " +
        "izni vermeniz gerekiyor.",
    };
  }

  const kayit = (await kayitAl()) || (await swKaydet());
  if (!kayit || !kayit.pushManager) {
    return { ok: false, hata: "Arka plan bileşeni kurulamadı." };
  }

  try {
    let abonelik = await kayit.pushManager.getSubscription();
    if (!abonelik) {
      abonelik = await kayit.pushManager.subscribe({
        // userVisibleOnly zorunludur: sessiz push tarayıcılarca yasaktır.
        userVisibleOnly: true,
        applicationServerKey: b64ToUint8(anahtar),
      });
    }
    await aboneligiSunucuyaYaz(abonelik);
    return { ok: true, hata: "" };
  } catch (e) {
    return { ok: false, hata: "Abonelik oluşturulamadı." };
  }
}

/** Bu cihazda kapatır (kişinin diğer cihazları etkilenmez). */
export async function pushKapat() {
  if (!destekVar()) return { ok: true };
  try {
    const kayit = await kayitAl();
    if (!kayit || !kayit.pushManager) return { ok: true };
    const abonelik = await kayit.pushManager.getSubscription();
    if (!abonelik) return { ok: true };
    const uc = abonelik.endpoint;
    try {
      await abonelik.unsubscribe();
    } catch (_) {}
    try {
      await pushAbonelikSil(uc);
    } catch (_) {}
    return { ok: true };
  } catch (_) {
    return { ok: false };
  }
}

// ── Her açılışta çalışan eşitleme ───────────────────────────────────────────

/**
 * Uygulama açılışında çağrılır. Üç iş yapar:
 *   1. Uzaktan kapatma bayrağını okur → açıksa nöbetçiyi SÖKER ve durur.
 *   2. Nöbetçiyi kaydeder/günceller.
 *   3. Zaten abone olan cihazın kaydını sunucuyla TAZELER.
 *
 * (3) neden gerekli: tarayıcı aboneliği kendiliğinden döndürebilir. Nöbetçi
 * oturumu okuyamadığı için sunucuya yeni adresi kendisi bildiremez (bunun için
 * internete kimlik doğrulamasız bir yazma ucu açmak gerekirdi). Eşitleme
 * kullanıcının bir sonraki açılışında burada olur.
 *
 * ASLA izin İSTEMEZ — izin yalnız kullanıcı düğmeye bastığında istenir.
 */
/**
 * FAZ-101 — SUNUCU BU CİHAZIN ABONELİĞİNİ GÖRÜYOR MU?
 *
 * Döner: "aktif" | "pasif" | "yok" | "bilinmiyor".
 * "bilinmiyor" iki hâlde olur: uç adresi yok (henüz abone değiliz) ya da
 * sunucuya ulaşılamadı. İkisi de "bir şey ters" DEMEK DEĞİLDİR — bu ayrım
 * önemli, çünkü ağ yokken "bağlantın kopmuş" demek kişiyi çalışan bir kurulumu
 * bozmaya iter.
 *
 * Hata YUTULUR: bu bir teşhis çağrısıdır, akışın hiçbir adımı buna bakmaz.
 */
export async function abonelikKontrolEt(uc = "") {
  if (!uc) return "bilinmiyor";
  try {
    const cevap = await pushAbonelikKontrol(uc);
    const hal = cevap && cevap.abonelik;
    return typeof hal === "string" ? hal : "bilinmiyor";
  } catch (_) {
    return "bilinmiyor";
  }
}

export async function senkronEt() {
  if (!destekVar()) return { durum: "desteklenmiyor" };

  // 1) Uzaktan kapatma (FAZ-84 §7.3). Sunucuya ulaşılamazsa sessiz geçilir —
  //    ağ yokluğu, nöbetçiyi sökmek için bir sebep değildir.
  try {
    const d = await pushDurumAl();
    if (d && d.kill) {
      await swSok();
      return { durum: "kapatildi" };
    }
  } catch (_) {}

  const kayit = await swKaydet();
  if (!kayit) return { durum: "kayit-yok" };

  if (izinDurumu() !== "granted") return { durum: "izin-yok" };

  try {
    const abonelik = await kayit.pushManager.getSubscription();
    if (!abonelik) return { durum: "abonelik-yok" };
    await aboneligiSunucuyaYaz(abonelik);
    return { durum: "eslendi" };
  } catch (_) {
    return { durum: "hata" };
  }
}
